import type { ListingProduct, ListingProductCode } from 'src/generated/graphql';

import { isFreemiumExperiment } from '../products';

import { listingProducts as listingProductsFreemium } from './freemium';
import { listingProducts as listingProductsShared } from './shared';

const listingProducts = isFreemiumExperiment
  ? listingProductsFreemium
  : listingProductsShared;

export interface ListingProductWithPackageInfo extends ListingProduct {
  productCode: ListingProductCode;
}

export const hasProductInfo = (
  listingProduct: ListingProduct,
): listingProduct is ListingProductWithPackageInfo =>
  listingProducts.some(
    (x) => listingProduct && x.productCode === listingProduct.productCode,
  );

export const getProductInfo = (listingProduct: ListingProductWithPackageInfo) =>
  listingProducts.find((x) => x.productCode === listingProduct.productCode)!;
